export default __webpack_public_path__ + "static/epilogue-c0d3f1a90dcf301217b0ac7986eeffb8.svg";